import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps } from '.';

export const Wrapper = styled.div<{ backgroundColor: string }>`
  min-width: 100%;
  min-height: 320px;
  position: relative;

  @media ${device.isMobile} {
    background: none;
    background-color: ${props => props.backgroundColor || colors.orange};
    padding-bottom: 0;
    min-height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const Text = styled.div`
  letter-spacing: -0.24px;
  color: ${colors.white};
  overflow-wrap: break-word;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 200px;
  z-index: 2;

  @media ${device.isMobile} {
    line-height: 38px;
    padding: 0 20px;
    height: auto;
  }

  @media ${device.isTablet} {
    margin: 0 36px;
    line-height: 46px;
    letter-spacing: -0.27px;
    position: relative;
  }

  @media ${device.isDesktop} {
    margin: 0 auto;
    width: 1024px;
    padding-top: 44px;
    box-sizing: border-box;
    align-items: unset;
    line-height: 46px;
    letter-spacing: -0.27px;
    position: relative;
  }
`;

export const TextInner = styled.h1`
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  @media ${device.isTablet} {
    max-width: 50%;
    font-size: 40px;
  }

  @media ${device.isDesktop} {
    max-width: 55%;
    font-size: 40px;
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${device.isMobile} {
    font-size: 30px;
  }
`;

export const Img = styled.span<ComponentProps>`
  background-size: cover;
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  display: none;

  @media ${device.isDesktop}, ${device.isTablet} {
    display: block;
  }
`;

/*
  The gradient is generated from https://cssgradient.io/
*/
export const ImgWrapper = styled.div<ComponentProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: -1px;
    height: 284px;
    width: 100%;
    background-size: contain;

    @media ${device.isTablet} {
      ${props =>
        props.imgUrl
          ? css`
              background: linear-gradient(
                110deg,
                ${props.backgroundColorPrimary || 'rgba(227, 113, 10, 1)'} 60%,
                ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 60%,
                ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 64%,
                transparent 64%
              );
            `
          : css`
              background: linear-gradient(110deg, ${
                props.backgroundColorPrimary || 'rgba(227, 113, 10, 1)'
              } 50%, ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 50%);
            `}
    }

    @media ${device.isDesktop} {
      ${props =>
        props.imgUrl
          ? css`
              background: linear-gradient(
                110deg,
                ${props.backgroundColorPrimary || 'rgba(227, 113, 10, 1)'} 55%,
                ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 55%,
                ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 57%,
                transparent 57%
              );
            `
          : css`
              background: linear-gradient(110deg, ${
                props.backgroundColorPrimary || 'rgba(227, 113, 10, 1)'
              } 55%, ${props.backgroundColorSecondary || 'rgba(250, 145, 0, 1)'} 55%);
            `}
    }
  }

  ${Img} {
    background-image: url(${props => props.imgUrl});
  }
`;
